// extracted by mini-css-extract-plugin
export default {"overlay":"fz-z","bodyOpen":"gz-z","content":"hz-z","header":"iz-z","close":"jz-z","closeNoHeading":"kz-z"};